<template>
  <div class="form-input" :style="{ width: width }">
    <label :for="name" class="input-label">{{ label }}</label>
    <input class="input-text"      
      :class="[{ 'is-input-error': error }, size]"    
      :style="{ width: width }"   
      :type="type"
      :name="name"
      :id="name"
      :disabled="disabled"    
      :placeholder="placeholder"
      :value="value"       
      @input="updateValue"
    >      
  </div>      
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String, 
      default: 'text'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'input'
    },
    label: { 
      type: String 
    },
    width: {
      type: String,
      default: '100%'
    }, 
    error: {
      type: [String, Boolean],
      default: false
    }   
  },
  data () {
    return {}
  },
  methods: {
    updateValue(e) {      
      this.$emit('update:value', e.target.value);            
    },
  },
}
</script>

<style scoped>
.form-input{
  margin-bottom: 16px;
}
.input-text{
  display: flex;
  align-items: center;
  /* display: inline-flex;
  justify-content: center; */
  align-self: stretch;  
  
  /* width: 100%; */
  border-radius: 4px;
  border: 1px solid var(--Gray-400, #CED4DA) !important;
  background: var(--Gray-White, #FFF);

  padding-left: 12px !important;
  gap: var(--ag-header-height, 4px);
}  
.input-text:hover{
  display: flex;
  /* padding: 6px 12px; */
  align-items: center;
  /* display: inline-flex;
  justify-content: center; */
  flex: 1 0 0;  

  border-radius: 4px;
  border: 1px solid var(--Components-Input-Focused-Border, #868E96);
  background: var(--Gray-White, #FFF);

  /* Active Shadow/Outline Primary */
  box-shadow: 0px 0px 0px 4px rgba(0, 0, 0, 0.25);
}
.input-text:active{
  display: flex;
  /* padding: 6px 12px; */
  align-items: center;
  /* display: inline-flex;
  justify-content: center; */
  flex: 1 0 0;  

  border-radius: 4px;
  border: 1px solid var(--Components-Input-Focused-Border, #868E96);
  background: var(--Gray-White, #FFF);

  /* Active Shadow/Outline Primary */
  box-shadow: 0px 0px 0px 4px rgba(0, 0, 0, 0.25);
} 
.input-text:disabled {
  border-radius: 4px;
  border: 1px solid var(--Gray-400, #CED4DA);
  background: var(--Gray-200, #E9ECEF); 
  }  
 .input-label{
  display: flex;
  padding-bottom: 8px;
  align-items: flex-end;
  /* align-items: center; */
  gap: var(--ag-header-height, 4px);
  align-self: stretch;
  background: var(--HitBox, rgba(255, 255, 255, 0.00));

  color: var(--Body-Text-Body-Color, #212529);
  /* Body/Regular */
  font-family: 'GingerFont', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
 } 
 .is-input-error {
    border: 1px solid red !important;
  }
.small{
  height: 31px;
  font-size: 14px;
}
.medium{
  height: 35px;
}
.large{
  height: 48px;
  font-size: 20px;
}
</style>